import React, {useEffect} from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../style/stairscleaning.css';
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-stairs1.png";
import imgServ2 from "../images/photo-stairs2.png";
import imgServ3 from "../images/photo-stairs3.png";
import imgServ4 from "../images/photo-stairs4.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Staircasecleaning() {
    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0);
      }, []);
    
      return (
        <div className="continer-office-cleaning">
          <div className="cover-img-content-stairs">
            <div className="photocontent-box">
              <Typography
              className='text-name-first-will'
                variant="h3"
                sx={{
                  color: "var(--mainColor)",
                  fontFamily: "var(--fontFamily)",
                  fontWeight: "medium",
                }}
              >
                Perfekte Sauberkeit im Treppenhaus.
              </Typography>
            </div>
          </div>
          <div className="content-text-for-services">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
        fontWeight: '700',
                }}
              >
                Für einen gepflegten ersten Eindruck
              </Typography>
            </div>
            <div
              className="text-body-service"
              data-aos="zoom-out"
              data-aos-anchor-placement="top-bottom"
              data-aos-offset="100"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <Typography
                gutterBottom
                variant="body2"
                sx={{
                  fontWeight: "normal",
                  fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}
              >
                Ein sauberes und gepflegtes Treppenhaus ist die Visitenkarte Ihrer Immobilie. Unsere professionelle Treppenhausreinigung sorgt für Ordnung, Hygiene und ein einladendes Erscheinungsbild – für Bewohner, Besucher und Mieter. <br/>
                <br /> Unsere erfahrenen Reinigungsteams reinigen gründlich alle Bereiche wie Treppen, Geländer, Böden, Wände und Gemeinschaftsflächen. Mit modernen Reinigungsmethoden und umweltfreundlichen Reinigungsmitteln entfernen wir zuverlässig Schmutz, Staub und Rückstände – effizient, schonend und nachhaltig. <br/>
                <br />Wir bieten flexible Reinigungspläne, die sich Ihren Anforderungen und Ihrem Zeitplan anpassen – von der regelmäßigen Unterhaltsreinigung bis hin zu Sonderreinigungen. <br/>
              <br />
              </Typography>
            </div>
            <div className="textandphoto-service">
              <div
                className="text-service-line"
                data-aos="fade-right"
                data-aos-offset="50"
                data-aos-duration="1000"
              >
                <h4>Ihre Vorteile auf einen Blick</h4>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Professionelle Reinigung für alle Treppenhäuser
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
               
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Gründliche und hygienische Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Zuverlässiger und pünktlicher Service
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Umweltfreundliche Reinigungsmittel
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Transparente Preise & Top-Bewertungen
                </Typography>
                
              </div>
              <div className="photo-service-line">
                <div
                  className="photo1-service"
                  data-aos="flip-left"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ1}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo2-service"
                  data-aos="flip-right"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ2}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content-text-for-services2">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
                  fontWeight: '700',
                }}
              >
                Entdecken Sie die Vorteile unserer Treppenhausreinigung!
              </Typography>
            </div>
            <div className="text-body-service2">
              <div
                className="text-for-service-body"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-offest="200"
                data-aos-duration="1000"
              >
                <Typography gutterBottom variant="body2" sx={{
                   fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}>
                  Unsere Treppenhausreinigungsdienste sind darauf ausgerichtet, nicht nur Sauberkeit zu gewährleisten, sondern auch Sicherheit und Komfort zu bieten. Ein ordentliches und gepflegtes Treppenhaus trägt wesentlich zum Wohlbefinden und zur Zufriedenheit der Bewohner bei. Deshalb gehen wir bei der Reinigung Ihrer Treppenhäuser äußerst gründlich vor.
                <br />Unser Team von Fachkräften ist mit modernster Ausrüstung und umweltfreundlichen Reinigungsmitteln ausgestattet, um Ihre Treppenhäuser von Schmutz, Staub und Flecken zu befreien. Wir kümmern uns um jede Ecke und jeden Winkel, damit Ihr Treppenhaus in bestem Zustand bleibt.
                <br />Darüber hinaus bieten wir flexible Reinigungspläne an, die Ihren Bedürfnissen und Zeitplänen entsprechen. Ob Sie eine regelmäßige wöchentliche Reinigung oder eine spezielle Reinigung vor besonderen Anlässen benötigen, wir sind für Sie da, um Ihren Anforderungen gerecht zu werden.
                </Typography>
              </div>
            </div>
            <div className="textandphoto-service2">
              <div
                className="text-service-line2"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Professionelle Reinigung für alle Arten von Treppenhausreinigung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                 
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Gründliche Entfernung von Schmutz, Staub und Rückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Streifenfreie und glänzende Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktliche und zuverlässige Dienstleistungen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wettbewerbsfähige Preise und transparente Abrechnung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Hochbewertete Reinigung.
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wohnungsreinigungsdienst in der Nähe von Städten
                </Typography>
              </div>
              <div className="photo-service-line2">
                <div
                  className="photo3-service"
                  data-aos="flip-left"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ4}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo4-service"
                  data-aos="flip-right"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ3}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    
          <Infokontakt />
          <Footer />
        </div>
      );
}

export default Staircasecleaning
